import React from "react"
import { useChangePassword } from "../../hooks/useChangePassword"

interface ChangePasswordFormProps {
  onChangePasswordSuccess?: () => void
}

export function ChangePasswordForm({
  onChangePasswordSuccess
}: ChangePasswordFormProps) {
  const {
    newPassword, setNewPassword,
    newPasswordConfirmation, setNewPasswordConfirmation,
    confirmationIsInvalid,
    submitting, error, submit,
  } = useChangePassword()

  const canSubmit = newPassword && newPasswordConfirmation

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    try {
      await submit()
      onChangePasswordSuccess?.()
    } catch {
      // error state is set by useChangePassword and surfaced below.
    }
  }

  return <form onSubmit={onSubmit}>
    <div className="mb-3">
      <span className='form-label'>New Password</span>
      <input name="password" type="password"
        className="form-control"
        required
        disabled={submitting}
        value={newPassword}
        onChange={(e) => { setNewPassword(e.target.value) }}></input>
    </div>

    <div className='mb-3'>
      <span className='form-label'>Confirm New Password</span>
      <input type='password' className={`form-control ${confirmationIsInvalid && 'is-invalid'}`}
        required
        value={newPasswordConfirmation}
        onChange={(e) => setNewPasswordConfirmation(e.target.value)}></input>

      <div id="validationServer04Feedback" className="invalid-feedback">
        This must match your new password
      </div>
    </div>

    <div className="mb-3">
      {submitting ?
        <button className='btn btn-primary disabled'>
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </button> :
        <button type='submit' className='btn btn-primary' disabled={!canSubmit}>Submit</button>}
    </div>


    <div className="mb-3">
      {error &&
        <p className="text-danger">
          {error.message}
        </p>}
    </div>
  </form>
}
